module.exports = __webpack_public_path__ + "img/face-unamused.4815668b.svg";